import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export type RecentViewType = 'candidate' | 'job';

export interface RecentViewItem {
  type: RecentViewType;
  /** Candidate slug or job _id. */
  id: string;
  title: string;
  subtitle?: string;
  viewedAt: number;
}

interface RecentViewsState {
  items: RecentViewItem[];
  addView: (item: Omit<RecentViewItem, 'viewedAt'>) => void;
  clear: () => void;
}

const MAX_RECENT = 10;

export const useRecentViews = create<RecentViewsState>()(
  persist(
    (set) => ({
      items: [],
      addView: (item) =>
        set((state) => {
          const deduped = state.items.filter(
            (i) => !(i.type === item.type && i.id === item.id),
          );
          const next = [{ ...item, viewedAt: Date.now() }, ...deduped].slice(0, MAX_RECENT);
          return { items: next };
        }),
      clear: () => set({ items: [] }),
    }),
    {
      name: 'bp-recent-views',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
